import contract from '@mailobj-browser/front/js/contracts/contract.js'
import aliases from './aliases/aliases.js'
import bookmarks from './bookmarks/bookmarks.js'
import create from './create/create.js'
import guardianship from './guardianship/guardianship.js'
import keys from './keys/keys.js'
import labo from './labo/labo.js'
import notes from './notes/notes.js'
import pgp_keys from './pgp_keys/pgp_keys.js'
import postit from './postit/postit.js'
import rss from './rss/rss.js'

export default contract({
    aliases,
    bookmarks,
    create,
    guardianship,
    keys,
    labo,
    notes,
    pgp_keys,
    postit,
    rss
})
